import { Entry } from '../Entry'

export function Entry20220802() {
  return (
    <Entry title="02/08/2022 - v3.1.4">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12723/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
